export default __webpack_public_path__ + "static/media/70.0dee05f4.svg";